import { render, staticRenderFns } from "./OnlineClassItem.vue?vue&type=template&id=795ba472&scoped=true&"
import script from "./OnlineClassItem.vue?vue&type=script&lang=js&"
export * from "./OnlineClassItem.vue?vue&type=script&lang=js&"
import style0 from "./OnlineClassItem.vue?vue&type=style&index=0&id=795ba472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795ba472",
  null
  
)

export default component.exports